import type { IFirstTouch } from "~/feature/attribution/type";
import type { Schemas } from "~/types/generated";

export type AuthCtaMode = "sign-up" | "sign-in";

export enum AuthNotice {
  AlreadySignedIn = "auth-already-signed-in",
  NewAccountsOnly = "auth-new-accounts-only",
}

export enum SignUpCampaign {
  Lifetime = "lifetime",
}

export interface ISignUpUnsafeMetadata
  extends SignUpUnsafeMetadata, Partial<IFirstTouch> {
  signupCampaign?: string;
}

export type ISignUpRequestBody = Schemas["SubmitEmailDto"];

export type GetUpdatesSource = ISignUpRequestBody["source"];

export interface ISignUpResponseBody {
  success: boolean;
  message: string;
}
